<template>
  <div id="ticket" class="div_card">
    <div v-if="docRecord==null">      
      <el-alert
        title="資料讀取中…"
        type="info"
        show-icon
        center
        :closable="false">
      </el-alert>
    </div>
    <div v-if="docRecord!=null">
      <div v-if="docRecord[0].status==1">
        <table class="w-100" style="background-color: azure; border: gray;" rules="all" bgcolor="#FFFFFF" >
          <tr>
                <td class="ncut-base-form-title" style="width: 14%;padding:0.5em;">考生姓名</td>
                <td style="padding:0.1em;">
                  <span class="badge badge-info" style="font-size:1.25rem">{{docRecord[0].name}}</span>
                </td>
                <td class="ncut-base-form-title" style="width: 14%;padding:0.5em;">報名編號</td>
                <td style="padding:0.1em;">
                  <span class="badge badge-info" style="font-size:1.25rem">{{docRecord[0].idNo}}</span>
                </td>
          </tr>  
          <tr>
                <td class="ncut-ipnut-form-ipt" colspan="4">
                  <div v-html="memo1">
                  </div> 
                  <div>
                    &nbsp;&nbsp;&nbsp;&nbsp;<span class="ncut-base-form-title">一、當日進入說明會會場人數(考生及親友)：</span>                    
                      <!-- <el-select v-model="docRecord[0].othrInfo.signNum" placeholder="請選擇" v-if="docRecord[0].deptName.substring(0,4)=='冷凍空調'">
                        <el-option
                          v-for="item in options"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                          :disabled="item.disabled">
                        </el-option>
                      </el-select>                     -->
                      <el-select v-model="docRecord[0].othrInfo.signNum" placeholder="請選擇">
                        <el-option
                          v-for="item in optionsothr"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                          :disabled="item.disabled">
                        </el-option>
                      </el-select>                    
                  </div>
                  <br>
                  <div>
                    &nbsp;&nbsp;&nbsp;&nbsp;<span class="ncut-base-form-title">二、當日入校之汽車車牌號碼(以利免費停車)：</span>
                  <el-input v-model="docRecord[0].othrInfo.carNo" style="width: 15em; " maxlength="10">
                  </el-input>
                  <span class="ncut-base-form-title">(機車一律免費進入)</span>
                </div>
                </td>
          </tr>    
          <tr>                
                <td class="ncut-ipnut-form-ipt" colspan="4" style="padding: 0.5em; text-align: center;">                  
                  <el-button type="success" @click="save()">儲存</el-button>                               
                </td>
              </tr>    
        </table> 
      </div>      
      <div v-else-if="docRecord[0].status==5">
        <el-alert
          title="請先完成網路報名及繳費。"
          type="error"
          show-icon
          center
          :closable="false">
        </el-alert>
      </div>      
      <div v-else>
        <el-alert
          title="無資料。"
          type="warning"
          show-icon
          center
          :closable="false">
        </el-alert>
      </div>
    </div>
    <div v-else>
      <el-alert
        title="尚無資料，請耐心等候，謝謝!!"
        type="warning"
        show-icon
        center
        :closable="false">
      </el-alert>
    </div>
  </div> 
</template>


<script>
export default {
  name: 'infoSign',
  data () {   
    return {      
        docRecord:null,     
        memo1: '',
        memo2: '',
        chkval: false ,
        options: [{
          value: 0,
          label: '請選擇',
          disabled: true
        }, {
          value: 1,
          label: '1人'
        }, {
          value: 2,
          label: '2人'
        }],
        optionsothr: [{
          value: 0,
          label: '請選擇',
          disabled: true
        }, {
          value: 1,
          label: '1人'
        }, {
          value: 2,
          label: '2人'
        }, {
          value: 3,
          label: '3人'
        }, {
          value: 4,
          label: '4人'
        }, {
          value: 5,
          label: '5人'
        }]
    }
  },
  computed: {
    sysId () {
      return this.$store.getters.getSysId
    },
    setting () {
      return this.$store.getters.getSetting
    },
    enroll () {
      return this.$store.getters.getEnrollInfo
    },
    user () {
      return this.$store.getters.getUser
    }
  },
  methods: {
    isSuccess(str) {
      return ((str == "true") || (str == "True") || (str == true) ? true : false);
    },
    print(dId) {
      let url = './WebApi/Apply/GetAdmiTicketPDF/'.concat(dId);
      let params = new URLSearchParams();
      params.append('cdn', this.cdnSelect);

      this.$http.get(url, {    
                  responseType: 'blob',
                  params: params
                }).then((response) => {
                  const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
                  const link = document.createElement('a');
                  link.href = url;
                  link.setAttribute('target','_blank');
                  document.body.appendChild(link);
                  link.click();
                });
    },
    getVirusMemo(fNo) {
      return this.$http
                 .get('./WebApi/Apply/GetVirusMemo/'.concat(this.sysId).concat('/').concat(fNo));
    },
    checkData() {
      var ret = false;
      var msg = '';

      if(0 == this.docRecord[0].othrInfo.signNum){
        msg = '請選擇進入會場人數!';
      }

      

      if (msg.length > 0) {
        this.$notify.error({
                            title: this.$t('message.Error_txt'),
                            dangerouslyUseHTMLString: true,
                            message: '<strong>對不起,請<i style="background:yellow;">'+msg+'</i>!</strong>',
                            offset: 150
                          });
      } else {
        ret = true;
      }
      return ret;
    },
    save() { 
      if(this.checkData()==true)
      {
        var vm = this; 
        vm.docRecord[0].dId=this.user.dId;
        vm.$http
        .put('./WebApi/Apply/SaveInfoSign',vm.docRecord[0])
        .then((success) =>{
                              if (vm.isSuccess(success.data)) {
                                vm.$message({
                                    message: '恭喜您,存檔成功',
                                    type: 'success'
                                  });                                
                                vm.query();
                              }
                          })
        .catch(function (error) {
          vm.$notify.error({
                            title: vm.$t('message.Error_txt'),
                            dangerouslyUseHTMLString: true,
                            message: '<strong>對不起,網路連線失敗' + error+'</strong>',
                            offset: 150
                          });
        }) 
      }     
    },
    query() {   
      var vm = this;
    　this.$http
        .get('./WebApi/Apply/GetInfoSign/'.concat(this.user.dId))
        .then(function(response) {
          if (response.data != null) {
            vm.docRecord = [response.data]
          } else {
            this.$notify.error({
                                title: this.$t('message.Error_txt'),
                                dangerouslyUseHTMLString: true,
                                message: '<strong>對不起,讀取<i style="background:yellow;">報名資料</i>失敗</strong>',
                                offset: 150
                              });
          }
        })
        .catch(function (error) {
          vm.$notify.error({
                            title: vm.$t('message.Error_txt'),
                            dangerouslyUseHTMLString: true,
                            message: '<strong>對不起,網路連線失敗' + error+'</strong>',
                            offset: 150
                          });
        })
    }
  },
  created () { 
    console.log('======created InfoSignView=====');
    //this.query();
    var vm = this;
    vm.query();
    this.$http.all([vm.getVirusMemo(52)])
              .then(vm.$http.spread(function (memoInfo) {              
                vm.memo1 = memoInfo.data;                 
              }))    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .td-style {
    width: 20%;
    text-align: right;
  }
</style>



// WEBPACK FOOTER //
// src/components/InfoSignView.vue